import type { TDateInput } from './date.types.ts';
import { filterEntries } from '#utils/object/index.ts';

const dateTimeComponentKeys = new Set<keyof Intl.DateTimeFormatOptions>([
  'dateStyle',
  'timeStyle',
  'weekday',
  'era',
  'year',
  'month',
  'day',
  'dayPeriod',
  'hour',
  'minute',
  'second',
  'fractionalSecondDigits',
  'timeZoneName',
]);

export const omitUndefinedOptions = (
  options: Intl.DateTimeFormatOptions,
): Intl.DateTimeFormatOptions =>
  filterEntries(options, (value) => value !== undefined);

export const getMonthOffset = (month: TDateInput, now: TDateInput): number => {
  const monthDate = new Date(month);
  const nowDate = new Date(now);
  const yearOffset = nowDate.getFullYear() - monthDate.getFullYear();

  return yearOffset * 12 + nowDate.getMonth() - monthDate.getMonth();
};

export const hasDateTimeComponents = (
  options: Intl.DateTimeFormatOptions,
): boolean =>
  Object.entries(options).some(
    ([key, value]) =>
      value !== undefined &&
      dateTimeComponentKeys.has(key as keyof Intl.DateTimeFormatOptions),
  );

export const isSameDay = (first: TDateInput, second: TDateInput): boolean =>
  new Date(first).toDateString() === new Date(second).toDateString();
